import JwtDecode from 'jwt-decode';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import { getIvKey, getSecretKey } from '@/constants/customInfo';
import JsPDF from 'jspdf';
import bmHannaAirBase64 from '@/assets/fonts/bmHannaAir.js';
import callChannelType from '@/constants/callChannelType';

const notificationMessage = (message, onClick) => {
  const notification = new Notification(message);
  // TODO : onClick 에 처리해야 될꺼 있음 추가
  // notification.onclick = onClick;

  notification.onclick = () => {
    notification.close();
  };
};

/**
 * 로그인 토큰에 있는 유저 정보를 decode
 * @returns {any} : JSON 형태의 decode 된 정보
 */
const parseLoginToken = () => {
  var token = localStorage.getItem('token');
  return token ? JSON.parse(JwtDecode(token).details) : null;
};

const getSenderUid = () => {
  let uid = localStorage.getItem('sid') || '';
  return uid;
};

const setSenderUid = (sid) => {
  localStorage.setItem('sid', sid);
};

const getLoginIdParam = () => {
  return localStorage.getItem('LOGIN_PARAM') || null;
};

const setLoginIdParam = (loginId) => {
  localStorage.setItem('LOGIN_PARAM', loginId);
};

// 채널명에 따른 아이콘 반환
const getChatRoomIcon = (moduleChannelName) => {
  if (moduleChannelName === 'WEB_CHAT') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png';
  } else if (moduleChannelName === 'NAVER_TALK') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_naver_talktalk.png';
  } else if (moduleChannelName === 'KAKAO_TALK') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_kakaotalk.png';
  } else if (moduleChannelName === 'SCENARIO') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_chatbot_v2.png';
  } else if (moduleChannelName === 'FACEBOOK_TALK') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_fb_msg.png';
  } else if (moduleChannelName === 'MAIL') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_mail.png';
  } else {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v1.png';
  }
};

const getChannelIcon = (moduleChannelName) => {
  if (moduleChannelName === '웹챗') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png';
  } else if (moduleChannelName === '네이버톡톡') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_naver_talktalk.png';
  } else if (moduleChannelName === '카카오톡') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_kakaotalk.png';
  } else if (moduleChannelName === '챗봇') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_chatbot_v2.png';
  } else if (moduleChannelName === '페이스북') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_fb_msg.png';
  } else if (moduleChannelName === '메일') {
    return 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_mail.png';
  } else {
    return '';
  }
};

const getCounselorIcon = (moduleChannelName) => {
  if (moduleChannelName === 'WEB_CHAT') {
    // return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-icon.png'
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-talk2-icon.png';
  } else if (moduleChannelName === 'NAVER_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/naver-icon.png';
  } else if (moduleChannelName === 'KAKAO_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/kakao-icon.png';
  } else if (moduleChannelName === 'FACEBOOK_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/facebook-icon.png';
  } else if (moduleChannelName === 'MAIL') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/mail-icon.png';
  } else {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-icon.png';
  }
};

// 모바일 여부 확인
const isMobile = () => {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
};

// Delete ToPath:KEY
const pathReplace = (arr, path, eject) => {
  if (path !== '/client/claim_information/create' && path !== '/client/claim_information/update') {
    Object.keys(arr).forEach((k) => {
      if (arr[k] && k !== eject) {
        path = path.replace(`/${arr[k]}`, '');
      }
    });
  }
  return path;
};

const mergeObject = (target, source) => {
  let obj = target;
  for (let key in source) {
    obj[key] = source[key];
  }

  return obj;
};

const excalDownload = (method, url, data, filename) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    let params = '?';
    if (method === 'GET') {
      Object.keys(data).map((d) => {
        params += `${d}=${data[d]}&`;
      });
    }
    xhr.open(method, process.env.BASE_URL + url + params.slice(0, -1));
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('authorization', `Bearer ${localStorage.getItem('token')}`);
    xhr.responseType = 'blob';
    xhr.onload = (e) => {
      if (e.currentTarget.status === 200) {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(e.currentTarget.response);
        link.download = `${filename}.xls`;
        link.click();
        resolve();
      } else {
        reject(e);
      }
    };

    xhr.send(JSON.stringify(data));
  });
};

const flatten = (list, key) => {
  return list.reduce((acc, curr) => {
    let newCurr = [];

    // key 아래에서 한 배열로 합치는 평탄화 작업을 하면서 property에서 빠져야지 무한루프 돌지않음
    if (curr.path) {
      newCurr.push({ ...curr, [key]: [], root: true });
    }

    if (curr && curr[key] && curr[key].length) {
      newCurr.push(...curr[key]);
    }

    return acc.concat(newCurr);
  }, []);
};

const getRouteList = (routeList, getPages = false) => {
  let newRouteList = [];
  newRouteList = flatten(routeList, getPages ? 'pages' : 'children');

  // 재귀 돌면서 하는일 1. children 을 모두 1 depth로 평탄화 시킴 2. pages 를 동일한 작업함
  // 모든 page route info를 1depth 배열로 만들어서 권한 체크 가능한 배열로 만든다
  if (newRouteList.find((route) => route.children && route.children.length)) {
    return getRouteList(newRouteList);
  }

  if (newRouteList.find((route) => route.pages && route.pages.length && typeof route.pages[0] !== 'string')) {
    return getRouteList(newRouteList, true);
  }

  return newRouteList;
};

const getMenuList = (list) => {
  return list.reduce((accumulator, currentValue) => {
    let newRouteList = getRouteList([currentValue]);
    return accumulator.concat(newRouteList);
  }, []);
};

const flattenWithEntries = (list) => {
  return list.reduce((acc, curr) => {
    const key = curr[0];
    const info = curr[1];
    let newCurr = [];

    if (info.path) {
      newCurr.push({ ...info, key, children: [] });
    }

    if (info && info.children && info.children.length) {
      newCurr.push(
        ...info.children.map((v) => {
          return {
            ...v,
            key
          };
        })
      );
    }

    return acc.concat(newCurr);
  }, []);
};

const flattenWithKey = (list, key) => {
  return list.reduce((acc, curr) => {
    let newCurr = [];

    if (curr.path) {
      newCurr.push({ ...curr, [key]: [] });
    }

    if (curr && curr[key] && curr[key].length) {
      newCurr.push(
        ...curr[key].map((v) => {
          return {
            ...v,
            key: curr.key
          };
        })
      );
    }

    return acc.concat(newCurr);
  }, []);
};

const getMenuListWithRole = (routeList, isRetry = false, getPages = false) => {
  let newRouteList = [];
  newRouteList = !isRetry ? flattenWithEntries(routeList) : flattenWithKey(routeList, getPages ? 'pages' : 'children');

  if (newRouteList.find((route) => route.children && route.children.length)) {
    return getMenuListWithRole(newRouteList, true, false);
  }

  if (newRouteList.find((route) => route.pages && route.pages.length && typeof route.pages[0] !== 'string')) {
    return getMenuListWithRole(newRouteList, true, true);
  }

  return newRouteList;
};

const getDateTime = (dateTime, format = 'YYYY-MM-DD HH:mm:ss') => {
  return dateTime ? moment(dateTime).format(format) : '-';
};

const replaceNewLine = (content) => {
  return content.replace(/(?:\r\n|\r|\n)/g, '<br/>');
};

const parseUTF8 = (value) => {
  return CryptoJS.enc.Utf8.parse(value);
};

const encryptByAES256 = (input) => {
  if (!input) {
    return;
  }
  var secretKey = parseUTF8(getSecretKey());
  var iv = parseUTF8(getIvKey());
  const cipher = CryptoJS.AES.encrypt(input, secretKey, {
    iv,
    mode: CryptoJS.mode.CBC
  });

  return cipher.toString();
};

const decryptByAES256 = (input) => {
  if (!input) {
    return;
  }
  var secretKey = parseUTF8(getSecretKey());
  var iv = parseUTF8(getIvKey());
  const cipher = CryptoJS.AES.decrypt(input, secretKey, {
    iv,
    mode: CryptoJS.mode.CBC
  });

  return cipher.toString(CryptoJS.enc.Utf8);
};

const parseToken = (token) => {
  return token ? JwtDecode(token) : null;
};

const getCallTypeFromToken = () => {
  try {
    const callServerType = parseLoginToken().callServerType;
    const channelTypes = [callChannelType.NEOMECCA, callChannelType.KT, callChannelType.KLCNS, callChannelType.NEO_WEB_RTC];
    return channelTypes.find((type) => callServerType.includes(type)) || '';
  } catch (e) {
    return '';
  }
};

const createPdfByText = ({ text, password, fileName }) => {
  return new Promise((resolve) => {
    const pdf = new JsPDF({
      encryption: {
        userPassword: password,
        ownerPassword: password
      }
    });

    // 폰트 추가 및 설정
    pdf.addFileToVFS('bmHannaAir.ttf', bmHannaAirBase64);
    pdf.addFont('bmHannaAir.ttf', 'bmHannaAir', 'normal');
    pdf.setFont('bmHannaAir');
    pdf.setFontSize(10);

    // 텍스트를 여러 페이지에 분할하는 로직
    let lines = pdf.splitTextToSize(text, 180);
    let y = 10;
    for (let i = 0; i < lines.length; i++) {
      if (y > 280) {
        pdf.addPage();
        y = 10; // 새 페이지 상단에서 시작
      }
      pdf.text(lines[i], 10, y);
      y += 10; // 다음 텍스트 줄의 위치
    }

    pdf.save(`${fileName}.pdf`);
    resolve();
  });
};

export default {
  getChannelIcon,
  notificationMessage,
  parseLoginToken,
  getSenderUid,
  setSenderUid,
  getLoginIdParam,
  setLoginIdParam,
  getChatRoomIcon,
  getCounselorIcon,
  isMobile,
  pathReplace,
  mergeObject,
  excalDownload,
  getMenuList,
  getMenuListWithRole,
  getDateTime,
  replaceNewLine,
  encryptByAES256,
  decryptByAES256,
  parseToken,
  getCallTypeFromToken,
  createPdfByText
};



// WEBPACK FOOTER //
// ./src/util/index.js